import { render } from "./ChatRooms.vue?vue&type=template&id=7ce7d2dc&scoped=true"
import script from "./ChatRooms.vue?vue&type=script&lang=js"
export * from "./ChatRooms.vue?vue&type=script&lang=js"

import "./ChatRooms.vue?vue&type=style&index=0&id=7ce7d2dc&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce7d2dc"]])

export default __exports__